import React, { useState, useEffect, useContext } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Loader from "../../components/Loader";
import PaymentChart from "../../components/PaymentChart";
import PaymentDetailModal from "../../components/PaymentDetailModal";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  TablePagination,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { ProfileContext } from "../../context/ProfileContext";

function Dashboard() {
  const { isLoading, fetchTransactions, payments, totalRecords } = useContext(ProfileContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [filter, setFilter] = useState("Monthly");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  useEffect(() => { fetchTransactions(page, rowsPerPage, filter) }, [page, rowsPerPage, filter]);

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); };
  const handleFilterChange = (e) => { setFilter(e.target.value); setPage(0) };
  const handleView = (row) => { setSelectedRow(row); setModalOpen(true); };
  const handleCloseModal = () => { setModalOpen(false); setSelectedRow(null); };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="comm_page_heading">Payment History</h6>
                  <p className="comm_page_sub_heading">Track and manage all patient payment transactions.</p>
                </div>
                <FormControl size="medium" sx={{ minWidth: 200 }}>
                  <InputLabel id="period-select-label" sx={{ fontSize: "1.4rem" }}>Period</InputLabel>
                  <Select labelId="period-select-label" id="period-select" value={filter} label="Period"
                    onChange={handleFilterChange}
                    sx={{ fontSize: "1.4rem", "& .MuiSelect-select": { fontSize: "1.1rem" }, }}
                    MenuProps={{ PaperProps: { sx: { "& .MuiMenuItem-root": { fontSize: "1.1rem" } }, }, }}
                  >
                    <MenuItem value="Weekly">Weekly</MenuItem>
                    <MenuItem value="Monthly">Monthly</MenuItem>
                    <MenuItem value="Yearly">Yearly</MenuItem>
                  </Select>
                </FormControl>
              </div>

              <PaymentChart
                title="Payment Revenue Overview"
                gradientId="paymentAreaGrad"
                color="#1A76EA"
                filter={filter}
              />
              <div className="ph-table-wrapper mt-4">
                <div className="ph-table-header">
                  <h6 className="ph-table-title">Transaction Records</h6>
                  <span className="ph-table-count">{totalRecords} total records</span>
                </div>

                <TableContainer component={Paper} className="ph-mui-table-container">
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        {["Sr. No.", "Patient Details", "Last Transaction Date", "Total Amount", "Total Transactions", "Action"].map((col) => (
                          <TableCell key={col} className="ph-table-head-cell">{col}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {payments.map((row, index) => (
                        <TableRow key={row.id} className="ph-table-row" hover>
                          <TableCell className="ph-table-cell">
                            {page * rowsPerPage + index + 1}
                          </TableCell>

                          <TableCell className="ph-table-cell">
                            <div className="ph-patient-info">
                              <span className="ph-patient-name">{row.patient}</span>
                              <span className="ph-patient-email">{row.email}</span>
                            </div>
                          </TableCell>

                          <TableCell className="ph-table-cell">
                            {new Date(row.lastTransaction).toLocaleDateString("en-US", {
                              month: "short", day: "numeric", year: "numeric",
                            })}
                          </TableCell>

                          <TableCell className="ph-table-cell ph-amount-cell">
                            ${row.amount.toFixed(2)}
                          </TableCell>

                          <TableCell className="ph-table-cell">
                            <span className="ph-method-badge">{row.transactionCount}</span>
                          </TableCell>

                          <TableCell className="ph-table-cell">
                            <Tooltip title="View Details" arrow>
                              <IconButton className="ph-eye-btn" onClick={() => handleView(row)}><Visibility fontSize="small" /></IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  <TablePagination
                    rowsPerPageOptions={[5, 8, 12]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    className="ph-pagination"
                  />
                </TableContainer>
              </div>

            </section>
          </div>
        </div>
      </div>
      <PaymentDetailModal
        open={modalOpen}
        onClose={handleCloseModal}
        row={selectedRow}
        filter={filter}
        fetchTransactions={fetchTransactions}
      />
    </>
  );
}

export default Dashboard;
